import { render } from "./ChatHolder.vue?vue&type=template&id=288d9048&scoped=true"
import script from "./ChatHolder.vue?vue&type=script&lang=js"
export * from "./ChatHolder.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-288d9048"

export default script